// 
import hash from "../../hash";
//
import { createApp } from "vue";
import b2bTypeahead from "../composant/b2bTypeahead";
import cardGroup from "../composant/cardGroup";
import { toDate } from "../composant/b2bLangue";

import Store from "../../Store";


import { bootbox, ModalHelper, B2bToast } from "../../B2bTools"
// @ts-ignore
import html from "./userDetail.html";
// @ts-ignore
import htmlDisable from "./userDetail@disable.html";
// @ts-ignore
import htmlDetailEdit from "./userDetail@edit.html";

const js = ({
    url: function (echangeur) {
        echangeur.addAction('user.edit', echangeur.hash, 'form', 'user');
        echangeur.addAction('utilisateur.profilList', echangeur.hash, 'form', 'profils');
        echangeur.addAction('utilisateur.profilsEditables', echangeur.hash, 'form', 'profilsEditables');
        echangeur.addAction('b2b.env.list', { filter: true }, '', 'universe')
        //
    },
    onLoad: function (echangeur) {

        let THIS = this;
        let isEditeur = echangeur.profilsEditables.rows.indexOf(echangeur.user.profil) >= 0;
        let userType = (echangeur.user.profil == "dmk-buy") ? "buyer" : "wholesale";

        const universe = echangeur.universe.rows.map(x => ({
            k: x.k,
            v: x.v,
            enable: !!(x.users.find(y => y.k === echangeur.user.k))
        }))

        const app = createApp({
            components: {
                "type-ahead": b2bTypeahead,
                "card-group": cardGroup,
            },
            data: () => ({
                user: echangeur.user,
                universe,
                //profils: echangeur.profils.rows,
                isEditeur: isEditeur,
                userType,
                isNotif: echangeur.user.notification?.front.global,
                isEdi: (echangeur.user.isEdi),
                ediEnabled: false,
            }),
            methods: {
                async activeUniver(u) {
                    const univer = echangeur.universe.rows.find(x => x.k === u.k)

                    if (u.enable) {
                        univer.users = univer.users.filter(x => x.k !== this.user.k)
                    } else {
                        univer.users.push({
                            k: this.user.k,
                            v: this.user.displayname + " (" + this.user.email + ")",
                            _id: this.user._id
                        })
                    }

                    await THIS.rest('b2b.env.save', {}, univer, '')
                },
                toProfil(k) {
                    let r = echangeur.profils.rows.find(el => { if (el.k == k) return el });
                    return (r) ? r.v : k;
                },
                toUsertype(k) {
                    return (k == "dmk-buy") ? "Buyer" : "Internal"
                },
                toDate: function (date) {
                    return toDate(date);
                },

                async addMember(group) {
                    if (!this.isEditeur) return;
                    if (!group._id) return;
                    let groupe = this.user.groupe.find(el => { return (el._id == group._id) })
                    if (!groupe) {
                        let result = await THIS.rest("groupe.addMember", { k: this.user.k, _id: group._id });
                        if (result.rows.indexOf(this.user.k) > -1) {
                            group.rows.push({ k: this.user.k })
                            this.user.groupe.push(group);
                        }
                    }

                },


                async remMember(group) {
                    if (!this.isEditeur) return;
                    let thisVue = this;
                    bootbox.confirm(
                        {
                            title: 'Remove Exclus',
                            message: `Are you sure to remove user from <b> ${group.v} </b> ?`
                        },
                        async function () {
                            let result = await THIS.rest("groupe.remMember", { k: thisVue.user.k, _id: group._id })

                            if (result.rows.indexOf(thisVue.user.k) == -1) thisVue.user.groupe = thisVue.user.groupe.filter(u => { return (u.k != group.k) })
                        })

                },
                typeaheadgroup() {
                    return async function (key) {
                        let v = await THIS.rest("groupe.typeahead", { k: key, limit: 10 })
                        let retour = [];
                        v.forEach(element => {
                            retour.push({ k: element.k, _id: element._id, type: element.type, v: element.v, rows: element.rows, vth: element.v + " (" + element.type + ")" });
                        });
                        return retour;
                    }
                },

                deleteUser() {
                    if (!this.isEditeur) return;
                    let thisVue = this;
                    bootbox.confirm(
                        {
                            title: 'Remove user',
                            message: `Are you sure to remove <b> ${this.user.displayname} </b> account ?`
                        },
                        async function () {
                            let result = await THIS.rest("user.del", { k: thisVue.user.k, email: thisVue.user.email }, { _id: thisVue.user._id });
                            if (result.ok) {
                                B2bToast(`${thisVue.user.displayname} deleted`, 'success')
                                THIS.fin();
                            }
                        })
                },
                changeStatus(active) {
                    if (!this.isEditeur) return;
                    let thisVue = this;

                    if (thisVue.user.status == 'D') {
                        bootbox.confirm(
                            {
                                title: 'Enable account',
                                message: `Enable <b> ${thisVue.user.email} </b> account ?`
                            },
                            async function () {
                                let result = await THIS.rest("user.enable", { k: thisVue.user.k, email: thisVue.user.email }, {});
                                thisVue.user.status = result.status;
                                thisVue.sendmailactivation()

                            })
                    } else {
                        bootbox.confirm(
                            {
                                title: 'Disable account',
                                message: `Disable <b> ${thisVue.user.email} </b> account ?`
                            },
                            async function () {
                                let result = await THIS.rest("user.disable", { k: thisVue.user.k, email: thisVue.user.email }, {});
                                thisVue.user.status = result.status;
                            })
                    }

                },

                async sendmailactivation() {
                    let thisVue = this;
                    if (this.user.status != "D") {
                        let result = await THIS.rest("user.sendmailactivation", { k: thisVue.user.k, }, { _id: thisVue.user._id, email: thisVue.user.email });
                        //B2bToast("Activation mail send");
                        B2bToast('Activation mail send', 'success')
                    }
                },

                async activeNotif() {
                    if (!this.isEditeur) return;
                    this.isNotif = !this.isNotif;
                    await THIS.rest("user.activeNotif", { email: this.user.email }, { notif: this.isNotif });
                },
                async activeEdi() {
                    console.log("passed")
                    if (!this.isEditeur) return;
                    this.isEdi = !this.isEdi;
                    await THIS.rest("user.activeEdi", { email: this.user.email }, { isEdi: this.isEdi });
                },

                userDetailDisable(e) {
                    const modaleApp = createApp({
                        data: () => ({
                        }),
                        methods: {
                            close() {
                                ModalHelper.hide();
                            },
                            disable() {
                                ModalHelper.hide();
                            }
                        },
                        mounted() {
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    // @ts-ignore
                    modaleApp.mount(ModalHelper.html(htmlDisable).container);

                },
                userEdit(user) {
                    if (!this.isEditeur) return;
                    let thisVue = this;
                    const modaleApp = createApp({
                        //
                        data: function () {
                            const profilsEditables = echangeur.profils.rows.filter(function (u) {
                                if (u.k == "dmk-buy") return false;
                                return (echangeur.profilsEditables.rows.indexOf(u.k) >= 0);
                            });
                            return {
                                isGroupCustomer: true,
                                isList: false,
                                user: user,
                                profilsEditables: profilsEditables,

                                row: [],
                                saisie: {
                                    email: user.email,
                                    displayname: user.displayname,
                                    profil: user.profil,
                                    initial: user.initial,
                                    title: user.title,
                                },
                                errors: {
                                    message: null,
                                    email: null,
                                    displayname: null,
                                    profil: null,
                                    nb: 0
                                },

                                userType
                            }
                        },
                        methods: {
                            close() {
                                ModalHelper.hide();
                            },
                            async valide() {
                                function nbe(objet) {
                                    let nb = 0;
                                    for (let key in objet) if (objet[key]) nb++;
                                    return nb;
                                }

                                this.errors = {}

                                if (this.saisie.displayname == "") this.errors.displayname = true;
                                if (this.saisie.profil == "") this.errors.profil = true;
                                if (this.saisie.email == "") this.errors.email = true;

                                if (!nbe(this.errors)) {

                                    let result = await THIS.rest("user.saveName", { _id: this.user._id }, this.saisie);
                                    if (result) {
                                        ModalHelper.hide();
                                        thisVue.user.displayname = result.displayname;
                                        thisVue.user.profil = result.profil;
                                        thisVue.user.initial = result.initial;
                                        thisVue.user.email = result.email;
                                        if (result.title) thisVue.user.title = result.title;
                                    }
                                }
                            },

                        },
                        mounted() {
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    // @ts-ignore
                    modaleApp.mount(ModalHelper.html(htmlDetailEdit).container);

                },
                back() {
                    hash.fin();
                }
            },
        });

        app.mount(THIS.c$('._vueChargement')[0]);

    },

});

export default {
    userDetail: { js: js, html: html }
};
